<template>
  <div class="ts-pb-3">
    <div class="ts-space-x-3 ts-flex ts-justify-end">
      <ts-button 
				:waiting="waiting_approve"
				:disabled="disabledButton" 
				color="primary" 
				@click="approve"
			>{{
        $t('approvalRequest.approve')
      }}</ts-button>
      <ts-button 
				color="danger" 
				@click="onReject"
				:disabled="disabledButton"
			>{{
        $t('approvalRequest.reject')
      }}</ts-button>
    </div>
    <ts-loading-banner :loading="loading">
      <div class="ts-rounded-md ts-overflow-hidden ts-mt-3">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th
                class="ts-bg-gray-200 ts-uppercase ts-border-r ts-px-3 ts-py-1 ts-border-blue-700 ts-w-3 ts-text-center"
              >
                <input
                  type="checkbox"
                  class="ts-mb-0"
                  :checked="checkAll"
                  @change="onCheckAll"
                />
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-w-10 ts-border-r ts-border-blue-700 ts-whitespace-no-wrap"
              >
                {{ $t('approvalRequest.requestStatus') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-40"
              >
                {{ $t('approvalRequest.requestDate') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-48"
              >
                {{ $t('approvalRequest.requestBy') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-56"
              >
                {{ $t('approvalRequest.origCommune') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-56"
              >
                {{ $t('approvalRequest.commune') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-24 ts-whitespace-no-wrap"
              >
                {{ $t('approvalRequest.arriveTime') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-8 ts-whitespace-no-wrap"
              >
                {{ $t('approvalRequest.durationTime') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase">
                {{ $t('approvalRequest.comment') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="ts-border-b ts-border-gray-200"
              v-for="(item, index) in resources"
              :key="index"
            >
              <td class="ts-px-3 ts-py-1">
                <input
                  v-model="model.request_id_list"
                  :value="item.request_id"
                  type="checkbox"
                  class="ts-mb-0"
                />
              </td>
              <td class="ts-px-3 ts-py-1">
                {{ item.request_status == 2 ? 'Change' : 'Add New' }}
              </td>
              <td class="ts-px-3 ts-py-1">{{ item.requested_date }}</td>
              <td class="ts-px-3 ts-py-1">{{ item.request_by_name }}</td>
              <td class="ts-px-3 ts-py-1">{{ item.ori_commune_name }}</td>
              <td class="ts-px-3 ts-py-1">{{ item.commune_name }}</td>
              <td class="ts-px-3 ts-py-1">{{ item.arrival_time }}</td>
              <td class="ts-px-3 ts-py-1">{{ item.duration_in_minute + ' minutes' }}</td>
              <td class="ts-px-3 ts-py-1">{{ item.request_comment }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import Comment from './comment.vue'
export default {
  name: 'pendingList',
  data() {
    return {
      loading: false,
      waiting_approve: false,
      rejecting: false,
      resources: [],
      errors: new Errors(),
      model: {
        request_id_list: [],
        app_type_id: 2, //For request change plan or new visit of location
        app_status: null,
        app_comments: null
      }
    }
  },
  computed: {
    checkAll() {
      if (this.resources.length) {
        return this.model.request_id_list.length == this.resources.length
      }
      return false
    },
		disabledButton(){
			return !this.model.request_id_list.length
		}
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('hr/approvalRequest', ['store']),
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('hr/approvalRequest/fetch', {
          filter: {
            app_type_id: '1,2',
            approve_status: 0,
          },
					perPage: -1
        })
        .then(response => {
          this.loading = false
          this.resources = response.data
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onCheckAll(e) {
      if (e.target.checked) {
        this.model.request_id_list = this.resources.map(el => el.request_id)
      } else {
        this.model.request_id_list = []
      }
    },
    approve() {
      this.waiting_approve = true
      this.errors = new Errors()
      this.model.app_status = 2
      this.store(this.model)
        .then(async response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_approve = false
        })
    },
    onReject() {
			this.model.app_status = 3
      this.$confirm({
        centered: true,
        okType: 'danger',
        title: this.$t('approvalRequest.are_you_sure_to_reject'),
        content: h =>
          h(Comment, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('approvalRequest.comment')
            }
          }),
        onOk: () =>  {
          return this.store(this.model)
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
							return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
							 return Promise.reject(error)
            })
        },
        cancelText: this.$t('no'),
        okText: this.$t('yes'),
        onCancel: () =>  {
					this.model.app_status = null
				}
      })
    }
  }
}
</script>
